import { Injectable } from '@angular/core';
import { Cart, CartModificationList } from '@spartacus/cart/base/root';
import { Observable } from 'rxjs';
import { GenAutoShipEntriesRequest, GenAutoShipScheduleDates } from '../../../../models/auto-ship.model';
import { GenAutoShipCartAdapter } from './auto-ship-cart.adapter';

@Injectable()
export class GenAutoShipCartConnector {
  constructor(private adapter: GenAutoShipCartAdapter) { }

  load(userId: string, cartId: string): Observable<Cart> {
    return this.adapter.load(userId, cartId);
  }

  updateEntries(
    userId: string,
    cartId: string,
    request: GenAutoShipEntriesRequest,
  ): Observable<CartModificationList> {
    return this.adapter.updateEntries(userId, cartId, request);
  }

  scheduleShipment(
    userId: string,
    cartId: string,
    request: GenAutoShipScheduleDates,
  ): Observable<unknown> {
    return this.adapter.scheduleShipment(userId, cartId, request);
  }
}
